"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSbHealth = exports.takeSbSecret = exports.fetchSbEvents = exports.fetchSbUnlinkedMembers = exports.fetchSbCandidates = exports.fetchSbEntries = void 0;
exports.performSbAction = performSbAction;
exports.setSbLevels = setSbLevels;
exports.giveSbSecret = giveSbSecret;
exports.fetchSbHealthReport = fetchSbHealthReport;
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
async function request(route, init = {}) {
    let response;
    try {
        response = await fetch(`${MainSetupReact_1.default.serverUrl}sbAccess/${route}`, { ...init, credentials: "include" });
    }
    catch {
        return { ok: false, status: 0, message: "" };
    }
    try {
        const body = await response.json();
        return response.ok ? { ok: true, data: body } : {
            ok: false, status: response.status, message: typeof body?.errorMessage === "string" ? body.errorMessage : "",
        };
    }
    catch {
        // Odpowiedź bez JSON zachowuje kod HTTP, a nie udaje braku sieci.
        return { ok: false, status: response.status, message: "" };
    }
}
const fetchSbEntries = () => request("entries");
exports.fetchSbEntries = fetchSbEntries;
const fetchSbCandidates = () => request("candidates");
exports.fetchSbCandidates = fetchSbCandidates;
const fetchSbUnlinkedMembers = () => request("githubMembers/unlinked");
exports.fetchSbUnlinkedMembers = fetchSbUnlinkedMembers;
const fetchSbEvents = (personId) => request(`${personId}/events`);
exports.fetchSbEvents = fetchSbEvents;
async function performSbAction(personId, action, githubLogin) {
    const response = await request(`${personId}/${action === "assign" ? "githubAccount" : action}`, action === "assign" ? {
        method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ githubLogin }),
    } : { method: "POST" });
    if (!response.ok)
        return response;
    if ((response.data?.result !== "OK" && response.data?.result !== "PARTIAL") || typeof response.data.note !== "string")
        return { ok: false, status: 200, message: "Nieprawidłowa odpowiedź serwera PS." };
    return { ok: true, result: response.data.result, note: response.data.note };
}
async function setSbLevels(personId, levels) {
    return request(`${personId}/levels`, {
        method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(levels),
    });
}
/** Wysyła wyłącznie szyfrogram i odcisk klucza, którym szyfrowano; jawne hasło nie opuszcza przeglądarki. */
function giveSbSecret(personId, name, ciphertext, keyThumbprint) {
    return request(`${personId}/secrets/${encodeURIComponent(name)}`, {
        method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ciphertext, keyThumbprint }),
    });
}
const takeSbSecret = (personId, name) => request(`${personId}/secrets/${encodeURIComponent(name)}`, { method: "DELETE" });
exports.takeSbSecret = takeSbSecret;
/** Prośba o świeży raport z komputera pracownika; instalator dośle go przy najbliższym sprawdzeniu. */
const requestSbHealth = (personId) => request(`${personId}/healthRequest`, { method: "POST" });
exports.requestSbHealth = requestSbHealth;
/** Ostatni raport jako plik JSON; nazwę (z nazwiskiem i datą) nadaje PS w Content-Disposition. */
async function fetchSbHealthReport(personId) {
    let response;
    try {
        response = await fetch(`${MainSetupReact_1.default.serverUrl}sbAccess/${personId}/healthReport`, { credentials: "include" });
    }
    catch {
        return { ok: false, status: 0, message: "" };
    }
    if (!response.ok) {
        let message = "";
        try {
            const body = await response.json();
            if (typeof body?.errorMessage === "string")
                message = body.errorMessage;
        }
        catch { /* bez JSON */ }
        return { ok: false, status: response.status, message };
    }
    const fileName = /filename="([^"]+)"/.exec(response.headers?.get("Content-Disposition") ?? "")?.[1] ?? "raport-sb.json";
    return { ok: true, data: { blob: await response.blob(), fileName } };
}
